/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
    PricingToJSONTyped,
} from './Pricing';
import type { RailTransportType } from './RailTransportType';
import {
    RailTransportTypeFromJSON,
    RailTransportTypeFromJSONTyped,
    RailTransportTypeToJSON,
    RailTransportTypeToJSONTyped,
} from './RailTransportType';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
    DirectionToJSONTyped,
} from './Direction';

/**
 * 
 * @export
 * @interface RailTransport
 */
export interface RailTransport {
    /**
     * The code of the railTransport
     * @type {string}
     * @memberof RailTransport
     */
    code: string;
    /**
     * 
     * @type {RailTransportType}
     * @memberof RailTransport
     */
    type: RailTransportType;
    /**
     * 
     * @type {Direction}
     * @memberof RailTransport
     */
    direction: Direction;
    /**
     * Rail class code
     * @type {string}
     * @memberof RailTransport
     */
    railClassCode: string;
    /**
     * Rail class name
     * @type {string}
     * @memberof RailTransport
     */
    railClassName: string;
    /**
     * Rail tariff code
     * @type {string}
     * @memberof RailTransport
     */
    railTariffCode: string;
    /**
     * Rail tariff name
     * @type {string}
     * @memberof RailTransport
     */
    railTariffName: string;
    /**
     * List of pricings. The sorting corresponds to the sorting of the guests/paxe
     * @type {Array<Pricing>}
     * @memberof RailTransport
     */
    pricings: Array<Pricing>;
}



/**
 * Check if a given object implements the RailTransport interface.
 */
export function instanceOfRailTransport(value: object): value is RailTransport {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('direction' in value) || value['direction'] === undefined) return false;
    if (!('railClassCode' in value) || value['railClassCode'] === undefined) return false;
    if (!('railClassName' in value) || value['railClassName'] === undefined) return false;
    if (!('railTariffCode' in value) || value['railTariffCode'] === undefined) return false;
    if (!('railTariffName' in value) || value['railTariffName'] === undefined) return false;
    if (!('pricings' in value) || value['pricings'] === undefined) return false;
    return true;
}

export function RailTransportFromJSON(json: any): RailTransport {
    return RailTransportFromJSONTyped(json, false);
}

export function RailTransportFromJSONTyped(json: any, ignoreDiscriminator: boolean): RailTransport {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'type': RailTransportTypeFromJSON(json['type']),
        'direction': DirectionFromJSON(json['direction']),
        'railClassCode': json['railClassCode'],
        'railClassName': json['railClassName'],
        'railTariffCode': json['railTariffCode'],
        'railTariffName': json['railTariffName'],
        'pricings': ((json['pricings'] as Array<any>).map(PricingFromJSON)),
    };
}

export function RailTransportToJSON(json: any): RailTransport {
    return RailTransportToJSONTyped(json, false);
}

export function RailTransportToJSONTyped(value?: RailTransport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'type': RailTransportTypeToJSON(value['type']),
        'direction': DirectionToJSON(value['direction']),
        'railClassCode': value['railClassCode'],
        'railClassName': value['railClassName'],
        'railTariffCode': value['railTariffCode'],
        'railTariffName': value['railTariffName'],
        'pricings': ((value['pricings'] as Array<any>).map(PricingToJSON)),
    };
}

